import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { errorInitialState } from './state';
import { GenericErrorType } from './types';

export const errorSlice = createSlice({
  name: 'error',
  initialState: errorInitialState,
  reducers: {
    showErrorDialog: (state, action: PayloadAction<GenericErrorType>) => {
      state.genericError = action.payload;
      return state;
    },
    hideErrorDialog: (state) => {
      state.genericError = errorInitialState.genericError;
      return state;
    },
    setErrorConnectionState: (state, action: PayloadAction<boolean>) => {
      state.connectionState.error = action.payload;
      return state;
    },

    showBetaAccessErrorDialog: (state) => {
      state.betaAccessError.error = true;
      return state;
    },
  },
});
